import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW9300Model } from '../kymw9300.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * お知らせ編集画面初期表示をするため、お知らせを取得するサービス
 *
 * @export GetInformationsService
 * @class GetInformationsService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetInformationsService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW9300Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetInformationsService
   */
  execute(model, successFunc: Function ): void {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getInformations', new PlessRequest());
  }

  /**
  * API通信成功時の処理
  *
  * @param {*} data レスポンスデータ
  * @memberof GetInformationsService
　*/
  success(data: any) {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
